<template>
  <div class="px-2" style="border: none">
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <div class="row nopads">
        <div class="col-sm-4">
          <div
            class="nopads"
            label-for="start"
          >
            <span class="span-title">{{ $t('work_time.start') }}</span>
            <input
              id="start"
              v-model="fromDate"
              class="form-control form-control-sm"
              type="date"
            />
          </div>
        </div>
        <div class="col-sm-4">
            <span class="span-title">{{ $t('work_time.end') }}</span>
            <input
              id="end"
              v-model="toDate"
              class="form-control form-control-sm"
              type="date"
            />
        </div>
      </div>
      <!-- User selection multiselect -->
      <div class="row nopads">
        <div class="col-sm-8">
          <span class="search-title">{{ $t('work_time.person') }}</span>
          <multiselect
            v-model="selectedUsers"
            class="multiselect_routa"
            :placeholder="$t('work_time.select_person')"
            :deselect-label="$t('common.remove_selection')"
            :select-label="$t('common.select')"
            :close-on-select="false"
            :multiple="true"
            label="name"
            track-by="name"
            :searchable="true"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :options="users"
          >
            <template
              #singleLabel="props"
            >
              <span class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
              </span>
            </template>
            <template
              #option="props"
            >
              <div class="option__desc">
                <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
              </div>
            </template>
            <template #noResult>
              <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
              <span>{{ $t('common.no_results') }}</span>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="col-sm-12 d-flex justify-content-end">
          <button type="reset" class="btn btn-danger form-button">
              {{ $t('ins_report.clear') }}
          </button>
          <button type="submit" class="btn btn-primary form-button">
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </form>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import Multiselect from 'vue-multiselect'
import {timeUtils} from '../mixins/TimeUtils'

export default {
    name: 'WorkTimeSearch',
    components: {Multiselect},
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            loading: false,
            users: [],
            selectedUsers: [],
            fromDate: null,
            toDate: null
        }
    },
    mounted: function () {
        this.fetchUsers()
        if (!this.fromDate) {
            this.fromDate = this.timestampToDateInput(this.getMonthStartAsDate().getTime())
        }
    },
    methods: {
        fetchUsers: function () {
            this.users = []
            this.restFetch(this.userUrl, this.handleUserResponse)
        },

        handleUserResponse: function (response) {
            if (response && response.data) {
                response.data.forEach(function (user) {
                    this.users.push({
                        value: user.id,
                        name: user.last_name + ', ' + user.first_name,
                        company: user.company ? user.company.name : '',
                        email: user.email
                    })
                }, this)
            }
            this.loading = false
        },

        onSubmit: function () {
            this.$emit('search', this.getSearchParams())
        },

        onReset: function () {
            this.selectedUsers = []
            this.fromDate = null
            this.toDate = null
        },

        getSearchParams() {
            var params = {}
            if (this.selectedUsers.length > 0) {
                let results = []
                this.selectedUsers.forEach(function (item) {
                    results.push(item.value)
                }, this)
                params.users = results
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.from = this.localTimeToUtcTime(this.fromDate).toISOString()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.to = this.getEndOfTheDay(this.toDate).toISOString()
            }
            return params
        }
    }
}
</script>


